import { StoreClient } from '@jbhi-fi/apis/src/algolia/StoreClient';
import { useQuery } from 'react-query';
import { usePublicApiClient } from '../usePublicApiClient';

type UseAlgoliaStoreProps = {
  algoliaApiClientProp?: StoreClient;
  locationId?: string;
  locationIds?: Array<string>;
};

export const useAlgoliaStore = ({ algoliaApiClientProp, locationId, locationIds }: UseAlgoliaStoreProps) => {
  const { algoliaStoreApiClient } = usePublicApiClient();

  const algoliaApiClient = algoliaApiClientProp || algoliaStoreApiClient;
  if (!algoliaApiClient) throw new Error('useAlgoliaStore must be used with an algoliaApiClient');

  const handleFetchStoreData = async () => {
    if (locationId) {
      return await algoliaApiClient.getStore(locationId);
    }
    if (locationIds?.length) {
      return await algoliaApiClient.getStores(locationIds);
    }
  };

  const { data, status, error } = useQuery({
    ...(locationIds?.length
      ? { enabled: Boolean(locationIds), queryKey: ['useAlgoliaStore', `locationIds: ${[locationIds]}`] }
      : locationId
      ? {
          enabled: Boolean(locationId),
          queryKey: ['useAlgoliaStore', `locationId: ${locationId}`],
        }
      : { enabled: false }),
    queryFn: handleFetchStoreData,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const isLoading = status === 'loading';

  return { isLoading, stores: data, error: error };
};
